import { useCallback, useEffect, useState } from "react";
import { playBillingDisponivel, precoNaPlay, assinarPelaPlay, restaurarPelaPlay, mensagemPlay } from "../utils/playBilling";

/* Assinatura pela Google Play nas telas de plano (conta nova e Configurações →
   Conta). Só no app Android com a assinatura configurada; fora dele, `usarPlay`
   é false e as telas seguem com o Mercado Pago. */
export function useAssinaturaPlay({ uid, onUpdate, setErro }) {
  const usarPlay = playBillingDisponivel();
  const [precoPlay, setPrecoPlay] = useState(null);
  const [ocupado, setOcupado] = useState(null); // "assinar" | "restaurar"

  useEffect(() => {
    if (!usarPlay) return undefined;
    let vivo = true;
    precoNaPlay().then(p => { if (vivo) setPrecoPlay(p); }).catch(() => {});
    return () => { vivo = false; };
  }, [usarPlay]);

  const aplicar = useCallback(r => {
    if (r?.ativo) {
      onUpdate(prev => ({ ...prev, plan: "monthly", planOrigem: "google_play", planExpiresAt: r.expiraEm ? new Date(r.expiraEm) : prev?.planExpiresAt }));
      return true;
    }
    if (r?.pendente) setErro("Pagamento em processamento na Google Play. O plano é liberado assim que ele for confirmado.");
    else if (r?.semCompra) setErro("Nenhuma assinatura ativa encontrada nesta conta da Google Play.");
    else setErro("A Google Play não confirmou a assinatura.");
    return false;
  }, [onUpdate, setErro]);

  const executar = useCallback(async (tipo, fn) => {
    setOcupado(tipo); setErro("");
    try { return aplicar(await fn()); }
    catch (e) { const msg = mensagemPlay(e); if (msg) setErro(msg); return false; }
    finally { setOcupado(null); }
  }, [aplicar, setErro]);

  const assinar = useCallback(() => executar("assinar", () => assinarPelaPlay(uid)), [executar, uid]);
  const restaurar = useCallback(() => executar("restaurar", () => restaurarPelaPlay()), [executar]);

  return { usarPlay, precoPlay, ocupado, assinar, restaurar };
}
